import { useState, useEffect } from "react";

/**
 * Custom hook for managing Google Maps instance and bounds
 */
export const useGoogleMaps = (schedules) => {
  const [mapInstance, setMapInstance] = useState(null);
  const [mapsInstance, setMapsInstance] = useState(null);

  // Update map bounds when schedules change
  useEffect(() => {
    if (mapInstance && mapsInstance && schedules.length > 0) {
      const bounds = new mapsInstance.LatLngBounds();
      let hasValidLocation = false;

      schedules.forEach((schedule) => {
        if (schedule.location?.latitude && schedule.location?.longitude) {
          bounds.extend({
            lat: parseFloat(schedule.location.latitude),
            lng: parseFloat(schedule.location.longitude),
          });
          hasValidLocation = true;
        }
      });

      if (hasValidLocation) {
        mapInstance.fitBounds(bounds);

        // Prevent over-zooming for single marker
        if (schedules.length === 1) {
          const listener = mapsInstance.event.addListener(
            mapInstance,
            "idle",
            () => {
              if (mapInstance.getZoom() > 16) mapInstance.setZoom(16);
              mapsInstance.event.removeListener(listener);
            }
          );
        }
      }
    }
  }, [mapInstance, mapsInstance, schedules]);

  return {
    mapInstance,
    mapsInstance,
    setMapInstance,
    setMapsInstance,
  };
};
